import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: false,
    type: "",
    userName: "",
  },
  reducers: {
    setLoginDetails: (state, action) => {
      state.isLoggedIn = action?.payload?.isLoggedIn;
      state.type = action?.payload?.type;
      state.userName = action?.payload?.userName;
    },
    clearLoginDetails: (state) => {
      state.isLoggedIn = false;
      state.type = "";
      state.userName = "";
    },
  },
});

export const { setLoginDetails, clearLoginDetails } = authSlice.actions;
export default authSlice.reducer;
